<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="71" height="52" fill="white" />
    <path
      opacity="0.8"
      d="M36.1807 3.54199C48.6845 3.54202 58.8213 13.6787 58.8213 26.1826C58.8212 38.6864 48.6845 48.8222 36.1807 48.8223C23.6769 48.8223 13.5402 38.6864 13.54 26.1826C13.54 13.6787 23.6768 3.54199 36.1807 3.54199ZM66.6094 18.7559C67.7096 18.756 68.6016 19.6487 68.6016 20.749C68.6014 21.8492 67.7095 22.7411 66.6094 22.7412C65.5091 22.7412 64.6174 21.8492 64.6172 20.749C64.6172 19.6487 65.509 18.7559 66.6094 18.7559ZM12.2725 1.00586C14.373 1.00586 16.076 2.70908 16.0762 4.80957C16.0762 6.91022 14.3731 8.61328 12.2725 8.61328C10.1718 8.61328 8.46875 6.91022 8.46875 4.80957C8.46894 2.70908 10.1719 1.00586 12.2725 1.00586Z"
      fill="url(#paint0_radial_410_32621)"
    />
    <path
      d="M47.5949 25.1897C48.3 25.1897 48.8776 24.6169 48.8136 23.9148C48.6853 22.5077 48.3452 21.1255 47.8026 19.8156C47.0969 18.1118 46.0624 16.5637 44.7584 15.2596C43.4544 13.9556 41.9063 12.9212 40.2025 12.2155C38.4987 11.5097 36.6725 11.1465 34.8284 11.1465C32.9842 11.1465 31.1581 11.5097 29.4543 12.2155C27.7505 12.9212 26.2023 13.9556 24.8983 15.2596C23.5943 16.5637 22.5599 18.1118 21.8541 19.8156C21.3116 21.1255 20.9714 22.5077 20.8431 23.9148C20.7791 24.6169 21.3567 25.1897 22.0618 25.1897L34.8284 25.1897H47.5949Z"
      fill="url(#paint1_linear_410_32621)"
    />
    <path
      d="M36.5697 40.1908C36.5777 40.8958 37.1569 41.4669 37.8583 41.3949C40.133 41.1616 42.3233 40.3754 44.2345 39.0966C46.1457 37.8179 47.708 36.0932 48.7916 34.0796C49.1257 33.4587 48.8188 32.7054 48.1701 32.429L37.3247 27.8083C36.9008 27.6277 36.431 27.942 36.4362 28.4028L36.5697 40.1908Z"
      fill="#A3B1D1"
    />
    <path
      d="M49.0239 30.4176C49.6919 30.6433 50.4224 30.2855 50.5865 29.5998C50.7032 29.1122 50.7937 28.6188 50.8576 28.1216C50.9474 27.4222 50.3914 26.8286 49.6868 26.8026L39.1216 26.4126C38.7537 26.399 38.6589 26.9161 39.0077 27.0339L49.0239 30.4176Z"
      fill="url(#paint2_radial_410_32621)"
    />
    <path
      d="M34.8284 12.4227C34.8284 11.7176 34.2556 11.14 33.5534 11.204C32.1463 11.3323 30.7641 11.6724 29.4543 12.215C27.7505 12.9207 26.2023 13.9551 24.8983 15.2592C23.5943 16.5632 22.5599 18.1113 21.8541 19.8151C21.1484 21.5189 20.7852 23.345 20.7852 25.1892C20.7852 27.0334 21.1484 28.8595 21.8541 30.5633C22.5599 32.2671 23.5943 33.8152 24.8983 35.1193C26.2023 36.4233 27.7505 37.4577 29.4543 38.1634C30.7642 38.706 32.1463 39.0462 33.5535 39.1744C34.2556 39.2384 34.8284 38.6608 34.8284 37.9558L34.8284 25.1892L34.8284 12.4227Z"
      fill="url(#paint3_radial_410_32621)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M45.9137 12.4016C46.4077 12.8369 46.4578 13.593 46.0255 14.0905L40.1315 20.8732C39.3895 21.7272 38.0905 21.7867 37.2745 21.0042L36.1412 19.9174L33.0022 23.1046C32.3818 23.7347 31.4226 23.8763 30.6487 23.4522L28.2671 22.147L25.2801 24.6023C24.7716 25.0203 24.0228 24.944 23.6077 24.432C23.1926 23.9199 23.2683 23.166 23.7768 22.748L26.9699 20.1233C27.5934 19.6108 28.4627 19.529 29.1696 19.9164L31.5237 21.2065L34.7266 17.9542C35.486 17.1831 36.7185 17.1654 37.4995 17.9143L38.6146 18.9838L44.2365 12.5142C44.6688 12.0167 45.4197 11.9663 45.9137 12.4016Z"
      fill="url(#paint4_radial_410_32621)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_410_32621"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(58.3661 -11.6071) rotate(118.314) scale(74.6291 80.338)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_410_32621"
        x1="22.7001"
        y1="24.0727"
        x2="36.105"
        y2="10.0295"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <radialGradient
        id="paint2_radial_410_32621"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(34.7593 34.4884) rotate(-32.1118) scale(18.9265 15.8308)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_410_32621"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(55.4896 4.31945) rotate(135.094) scale(49.4553 55.1628)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_410_32621"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(45.131 20.4336) rotate(-180) scale(54.9454 30.1099)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
    </defs>
  </svg>
</template>
